export const ROUTES = {
  LOGIN: "/login",
  RESETPASSWORD: "/reset-password",
  DASHBOARD: "/admin/dashboard",         
  // DASHBOARD: "/receptionist",         
  TRAINER_DASHBOARD: "/trainer",           
  MEMBER_DASHBOARD: "/trainer",   
  RECEPTIONIST_DASHBOARD: "/receptionist",    
  ReceptNotification: "/receptionist/notifications",   
  HOME: "/receptionist",                    
  PROFILE: "/profile",
  NOT_FOUND: "*",
};
